class RoutingViewModel {
    public data?: any;
}

const routingVM = new RoutingViewModel();
export default routingVM;